import bgmHome from "@assets/audios/bgm/bgm-home.mp3";
import sfxGameOver from "@assets/audios/sfx/sfx-gameover.wav";
import sfxButton from "@assets/audios/sfx/sfx-button.wav";
import sfxSlide from "@assets/audios/sfx/sfx-slide.wav";
import sfxSwoosh from "@assets/audios/sfx/sfx-swoosh.wav";
import sfxDing from "@assets/audios/sfx/sfx-ding.wav";
import sfxSeaDead from "@assets/audios/sfx/monsters/sfx-sea-dead.wav";
import sfxDesertDead from "@assets/audios/sfx/monsters/sfx-desert-dead.wav";
import sfxForestDead from "@assets/audios/sfx/monsters/sfx-forest-dead.wav";
import sfxFactoryDead from "@assets/audios/sfx/monsters/sfx-factory-dead.wav";
import sfxSeaObstacle from "@assets/audios/sfx/obstacles/sfx-sea-obstacle.wav";
import sfxDesertObstacle from "@assets/audios/sfx/obstacles/sfx-desert-obstacle.wav";
import sfxForestObstacle from "@assets/audios/sfx/obstacles/sfx-forest-obstacle.wav";
import sfxFactoryObstacle from "@assets/audios/sfx/obstacles/sfx-factory-obstacle.wav";

export type BgmKey = keyof typeof BGM_AUDIO_CATALOG;
export type SfxKey = keyof typeof SFX_AUDIO_CATALOG;
export type AudioKey = keyof typeof AUDIO_CATALOG;

export const BGM_AUDIO_CATALOG = {
  "bgm-home": bgmHome,
} as const;

export const SFX_AUDIO_CATALOG = {
  "sfx-button": sfxButton,
  "sfx-slide": sfxSlide,
  "sfx-swoosh": sfxSwoosh,
  "sfx-ding": sfxDing,
  "sfx-sea-dead": sfxSeaDead,
  "sfx-desert-dead": sfxDesertDead,
  "sfx-forest-dead": sfxForestDead,
  "sfx-factory-dead": sfxFactoryDead,
  "sfx-sea-obstacle": sfxSeaObstacle,
  "sfx-desert-obstacle": sfxDesertObstacle,
  "sfx-forest-obstacle": sfxForestObstacle,
  "sfx-factory-obstacle": sfxFactoryObstacle,
  "sfx-game-over": sfxGameOver,
} as const;

export const AUDIO_CATALOG = {
  ...BGM_AUDIO_CATALOG,
  ...SFX_AUDIO_CATALOG,
} as const;

export function preloadAudio(scene: Phaser.Scene) {
  scene.load.audio("bgm-home", bgmHome);

  scene.load.audio("sfx-button", sfxButton);
  scene.load.audio("sfx-slide", sfxSlide);
  scene.load.audio("sfx-swoosh", sfxSwoosh);
  scene.load.audio("sfx-ding", sfxDing);
  scene.load.audio("sfx-sea-dead", sfxSeaDead);
  scene.load.audio("sfx-desert-dead", sfxDesertDead);
  scene.load.audio("sfx-forest-dead", sfxForestDead);
  scene.load.audio("sfx-factory-dead", sfxFactoryDead);
  scene.load.audio("sfx-sea-obstacle", sfxSeaObstacle);
  scene.load.audio("sfx-desert-obstacle", sfxDesertObstacle);
  scene.load.audio("sfx-forest-obstacle", sfxForestObstacle);
  scene.load.audio("sfx-factory-obstacle", sfxFactoryObstacle);
  scene.load.audio("sfx-game-over", sfxGameOver);
}
